<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="优惠券"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="优惠券名称">
          <el-input size="mini" v-model="params.CouponName" placeholder="请输入类别名称" clearable />
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="params.AccountWay" placeholder="请选择类型" clearable>
            <el-option label="抵用" :value="0"></el-option>
            <el-option label="满减" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="CouponName" label="优惠券名称" />
        <el-table-column label="封面图片" align="center" width="125px">
          <template slot-scope="{row}">
            <el-image v-if="row.CouponCover" :src="'/api' + row.CouponCover" style="width:100px;margin-top:8px;"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="CouponType" label="类型">
          <template slot-scope="{row}">
            {{row.CouponType==0?"抵用":"满减"}}
          </template>
        </el-table-column>

        <el-table-column prop="FaceValue" label="面值" />
        <el-table-column prop="LeastAmount" label="使用条件" />
        <el-table-column prop="AccountWay" label="到账方式">
          <template slot-scope="{row}">
            {{row.AccountWay==0?"点击领取":"自动到账"}}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="LinkType" label="使用满足金额" />
        <el-table-column prop="LinkType" label="优惠减免金额" />
        <el-table-column prop="LinkType" label="优惠折扣" />
        <el-table-column prop="LinkType" label="每商家领用数量" />
        <el-table-column prop="LinkType" label="是否和活动同时使用" /> -->
        <el-table-column prop="EndDate" label="有效期">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.StartDate)}}</span>
            <span style="margin: 0 8px;">~</span>
            <span>{{$commonJs.toDateString(row.EndDate)}}</span>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/sale/coupon").default,
      params: {
        CouponName: "",
        AccountWay: null,
      },
    };
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve,reject) => {
        resolve({Count: 0, Data: []});
      })
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>